export class Tabs {
  static EDIT = 'edit'

  static MASKS = 'masks'

  static FLOORING = 'flooring'

  static SCHEMES = 'schemes'
}
